import { Link } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { PageSectionTitle } from 'src/components/selfService/layout/PageSectionTitle/PageSectionTitle';

const CARE_EMAIL = 'corporatecare@grubhub.com';
const CARE_EMAIL_HREF = `mailto:${CARE_EMAIL}`;
const CARE_PHONE = '(844) 478-2249';

export function LegacyContact(): JSX.Element {
  return (
    <PageSectionTitle
      title="Need help?"
      subtitle={
        <>
          We’re happy to answer any questions. Contact our Care team for support
          at <Link href={CARE_EMAIL_HREF}>{CARE_EMAIL}</Link> or {CARE_PHONE}.
        </>
      }
    />
  );
}
